<ion-header class="ion-no-border inventory-history-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-label slot="start">
      <ion-title> Inventory History </ion-title>
    </ion-label>
  </ion-toolbar>
  <ion-toolbar>
        <ion-searchbar
          class="ion-no-padding"
          type="search"
          animated="true"
          placeholder="Search keywords"
          (input)="search($event)"
        >
        </ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <p-table
    #table
    *ngIf="stats.length != 0"
    dataKey="id"
    [columns]="cols"
    [value]="stats"
    [loading]="isLoading"
    [responsive]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['dateTime', 'productName', 'adjustment', 'action']"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
  >

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          <div>
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-stat let-columns="columns">
      <tr>
        <td>
          <span class="p-column-title"><b>Date</b></span>
          <span>{{ stat.dateTime | date: "yyyy MMM dd, EEE hh:MM a" }}</span>
        </td>
        <td>
          <span class="p-column-title"><b>Product</b></span>
          <span>{{ stat.productName }}</span>
        </td>
        <td>
          <span class="p-column-title"><b>Adjustment</b></span>
          <span>{{ stat.adjustment }}</span>
        </td>
        <td>
          <span class="p-column-title"><b>Action</b></span>
          <span>{{ stat.action }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="stats.length == 0" style="text-align: center">NO DATA</div>
</ion-content>
